declare var CONTENT_API_URL: string;
export const baseUrl = CONTENT_API_URL;
export const headers: {
    'Accept': string;
    'Content-Type': string;
} = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
};